import { AccentArrow, ArrowDown, ArrowUp, ArrowIn, ArrowLeft, ArrowLineDown, ArrowOut, ArrowRight, ArrowUpRight, Atention, CaretDown, CaretLeft, CaretRight, CaretUp, Check, Minus, NotePencil, Search, Times, Plus, LocationPinSelected, LocationPin, Download, Info, Newspaper, Hamburguer, ReziseTextArea, Zoom, ZoomLight, List, ListLight, Facebook, Youtube, LinkedIn, Instagram } from '/react4xp/components/Svg/Others/Icons';

export const icons = [
    { name: 'AccentArrow', component: AccentArrow },
    { name: 'ArrowDown', component: ArrowDown },
    { name: 'ArrowUp', component: ArrowUp },
    { name: 'ArrowIn', component: ArrowIn },
    { name: 'ArrowLeft', component: ArrowLeft },
    { name: 'ArrowLineDown', component: ArrowLineDown },
    { name: 'ArrowOut', component: ArrowOut },
    { name: 'ArrowRight', component: ArrowRight },
    { name: 'ArrowUpRight', component: ArrowUpRight },
    { name: 'Atention', component: Atention },
    { name: 'CaretDown', component: CaretDown },
    { name: 'CaretLeft', component: CaretLeft },
    { name: 'CaretRight', component: CaretRight },
    { name: 'CaretUp', component: CaretUp },
    { name: 'Check', component: Check },
    { name: 'Minus', component: Minus },
    { name: 'NotePencil', component: NotePencil },
    { name: 'Search', component: Search },
    { name: 'Times', component: Times },
    { name: 'Plus', component: Plus },
    { name: 'LocationPinSelected', component: LocationPinSelected },
    { name: 'LocationPin', component: LocationPin },
    { name: 'Download', component: Download },
    { name: 'Info', component: Info },
    { name: 'Newspaper', component: Newspaper },
    { name: 'Hamburguer', component: Hamburguer },
    { name: 'ReziseTextArea', component: ReziseTextArea },
    { name: 'Zoom', component: Zoom },
    { name: 'ZoomLight', component: ZoomLight },
    { name: 'List', component: List },
    { name: 'ListLight', component: ListLight },
    { name: 'Facebook', component: Facebook },
    { name: 'Youtube', component: Youtube },
    { name: 'LinkedIn', component: LinkedIn },
    { name: 'Instagram', component: Instagram }
];
